import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../styled/flexbox.styled"
import { Spinner } from "@blueprintjs/core"

export const FlexContainerFullHeight = styled(FlexContainer)<{ position?: string }>`
  height: 100%;
  position: ${props => props.position || "static"};
`

export const SpinnerCenter = styled(Spinner)`
  margin: 7px auto;
`
